import { Link } from 'react-router-dom';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { H5, H6, Body2 } from '../../themes/typography';

function TermsAndFaqs({
    shmoozTerms = '<p>Shmooz Terms and Conditions</p>',
    eventOrganizerTerms = '<p>Event Organizer Terms and Conditions</p>',
    shmoozFaqs = '<p>Shmooz FAQs</p>',
    eventOrganizerFaqs = '<p>Event Organizer FAQs</p>'
}) {
    return (
        <div className="event-preview-terms-and-faqs-container">
            <Accordion
                sx={{
                    alignSelf: 'stretch',
                    fontWeight: 400,
                    background: 'var(--gradient-blue)',
                    color: 'var(--quaternary-color)',
                    borderRadius: '1rem !important',
                    boxShadow: 'none',
                    textAlign: 'justify',
                    '& .MuiAccordionSummary-root': {
                        minHeight: '56px'
                    },
                    '& .MuiAccordionSummary-expandIconWrapper': {
                        color: 'var(--quaternary-color)'
                    }
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <H5 fontWeight={700}>Terms & Conditions</H5>
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <Accordion
                            sx={{
                                alignSelf: 'stretch',
                                fontWeight: 400,
                                background: 'var(--gradient-blue)',
                                color: 'var(--quaternary-color)',
                                borderRadius: '1rem !important',
                                boxShadow: 'none',
                                textAlign: 'justify',
                                '& .MuiAccordionSummary-root': {
                                    minHeight: '56px'
                                },
                                '& .MuiAccordionSummary-expandIconWrapper': {
                                    color: 'var(--quaternary-color)'
                                }
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <H6>Shmooz</H6>
                            </AccordionSummary>
                            <AccordionDetails>
                                {/* <div
                                    dangerouslySetInnerHTML={{ __html: shmoozTerms }}
                                    style={{
                                        color: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)'
                                    }}
                                ></div> */}
                                <Body2>
                                    For more information, please visit our{' '}
                                    <Link to="/pages/terms-and-conditions" style={{ color: 'var(--tertiary-color)' }}>
                                        Terms & Conditions
                                    </Link>
                                </Body2>

                            </AccordionDetails>
                        </Accordion>
                        <Accordion
                            sx={{
                                alignSelf: 'stretch',
                                fontWeight: 400,
                                background: 'var(--gradient-blue)',
                                color: 'var(--quaternary-color)',
                                borderRadius: '1rem !important',
                                boxShadow: 'none',
                                textAlign: 'justify',
                                '& .MuiAccordionSummary-root': {
                                    minHeight: '56px'
                                },
                                '& .MuiAccordionSummary-expandIconWrapper': {
                                    color: 'var(--quaternary-color)'
                                }
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <H6 fontWeight={700}>Event Organizer</H6>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div
                                    dangerouslySetInnerHTML={{ __html: eventOrganizerTerms }}
                                    style={{
                                        color: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)'
                                    }}
                                ></div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion
                sx={{
                    alignSelf: 'stretch',
                    fontWeight: 400,
                    background: 'var(--gradient-blue)',
                    color: 'var(--quaternary-color)',
                    borderRadius: '1rem !important',
                    boxShadow: 'none',
                    textAlign: 'justify',
                    '& .MuiAccordionSummary-root': {
                        minHeight: '56px'
                    },
                    '& .MuiAccordionSummary-expandIconWrapper': {
                        color: 'var(--quaternary-color)'
                    }
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <H5 fontWeight={700}>FAQs</H5>
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {/* <Accordion
                            sx={{
                                alignSelf: 'stretch',
                                fontWeight: 400,
                                background: 'var(--gradient-blue)',
                                color: 'var(--quaternary-color)',
                                borderRadius: '1rem !important',
                                boxShadow: 'none',
                                textAlign: 'justify',
                                '& .MuiAccordionSummary-root': {
                                    minHeight: '56px'
                                },
                                '& .MuiAccordionSummary-expandIconWrapper': {
                                    color: 'var(--quaternary-color)'
                                }
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <H6>Shmooz</H6>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div
                                    dangerouslySetInnerHTML={{ __html: shmoozFaqs }}
                                    style={{
                                        color: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)'
                                    }}
                                ></div>
                            </AccordionDetails>
                        </Accordion> */}
                        <Accordion
                            sx={{
                                alignSelf: 'stretch',
                                fontWeight: 400,
                                background: 'var(--gradient-blue)',
                                color: 'var(--quaternary-color)',
                                borderRadius: '1rem !important',
                                boxShadow: 'none',
                                textAlign: 'justify',
                                '& .MuiAccordionSummary-root': {
                                    minHeight: '56px'
                                },
                                '& .MuiAccordionSummary-expandIconWrapper': {
                                    color: 'var(--quaternary-color)'
                                }
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <H6 fontWeight={700}>Event Organizer</H6>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div
                                    dangerouslySetInnerHTML={{ __html: eventOrganizerFaqs }}
                                    style={{
                                        color: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)'
                                    }}
                                ></div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}

export default TermsAndFaqs;
